import { getNumber } from "./getNumber.js";
export function peakTableCreator(data, options = {}) {
    const { xFactor = 1, yFactor = 1 } = options.info || {};
    let firstX = Infinity;
    let lastX = -Infinity;
    let firstY = Infinity;
    let lastY = -Infinity;
    const lines = [];
    for (let i = 0; i < data.x.length; i++) {
        const x = data.x[i];
        const y = data.y[i];
        if (firstX > x) {
            firstX = x;
        }
        if (lastX < x) {
            lastX = x;
        }
        if (firstY > y) {
            firstY = y;
        }
        if (lastY < y) {
            lastY = y;
        }
    }
    lines.push(`##FIRSTX=${firstX}`, `##LASTX=${lastX}`, `##FIRSTY=${firstY}`, `##LASTY=${lastY}`, `##XFACTOR=${xFactor}`, `##YFACTOR=${yFactor}`, '##PEAK TABLE=(XY..XY)');
    for (let i = 0; i < data.x.length; i++) {
        lines.push(`${getNumber(data.x[i], xFactor)} ${getNumber(data.y[i], yFactor)}`);
    }
    return lines;
}
//# sourceMappingURL=peakTableCreator.js.map